import { useCallback, useRef, useState } from 'react'

/**
 * Предоставляет популярное апи для работы с boolean
 *
 * @param initial - начальное состояние флага
 * @returns - функции, по работе с флагом: переключение, установка общего и конкретных значений
 */
export const useBooleanFlag = (initial: boolean) => {
  const [value, setValue] = useState(initial)

  const toggle = useCallback(() => {
    setValue(prev => !prev)
  }, [])

  const setTrue = useCallback(() => {
    setValue(true)
  }, [])

  const setFalse = useCallback(() => {
    setValue(false)
  }, [])

  const api = { toggle, setTrue, setFalse, setValue }

  return [value, api] as const
}

const dummy: UseBooleanFlagApi = {
  setFalse: () => {
    console.log('Не удалось установить false')
  },
  setTrue: () => {
    console.log('Не удалось установить true')
  },
  toggle: () => {
    console.log('Не удалось переключить флаг')
  },
  setValue: () => {
    console.log('Не удалось установить значение флага')
  },
}

export const useBooleanFlagApi = () => {
  return useRef(dummy)
}

export type UseBooleanFlagApi = {
  toggle: () => void
  setTrue: () => void
  setFalse: () => void
  setValue: React.Dispatch<React.SetStateAction<boolean>>
}
